import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Edu (Trang chủ, Chứng chỉ, Thư viện, Khoá học, Bài kiểm tra, Lộ trình). Mã nghiệp vụ và dữ liệu mẫu không dịch.
addMessages('vi', {
  'ed.learning': 'Đang học',
  'ed.dueSoon': 'Bắt buộc sắp hạn',
  'ed.forSeat': 'Gợi ý cho ghế',
  'ed.certsSoon': 'Chứng chỉ sắp hết hạn',
  'ed.renewed': 'Đã tải bản gia hạn',
  'ed.renew': 'Tải bản gia hạn',
  'ed.allValid': 'Còn hạn hết',
  'ed.continue': 'Học tiếp',
  'ed.reconnecting': 'Đang thử kết nối lại…',
  'ed.retry': 'Thử lại',
  'ed.openLib': 'Mở Thư viện',
  'ed.extend': 'Gia hạn',
  'ed.hPerson': 'Người',
  'ed.hCert': 'Chứng chỉ',
  'ed.hSource': 'Nguồn',
  'ed.hExpires': 'Hết hạn',
  'ed.hStatus': 'Trạng thái',
  'ed.hScan': 'Bản scan',
  'ed.noCert': 'Không có chứng chỉ nào khớp',
  'ed.lDoc': 'Tài liệu',
  'ed.lType': 'Loại',
  'ed.lDept': 'Phòng',
  'ed.lUpdated': 'Cập nhật',
  'ed.quizTitle': 'Bài kiểm tra do Ask HANA sinh từ SOP đang hiệu lực · người phụ trách SOP duyệt',
  'ed.quiz': 'Bài kiểm tra ⓘ',
  'ed.noDoc': 'Không có tài liệu nào khớp',
  'ed.cCourse': 'Khoá',
  'ed.cContent': 'Nội dung',
  'ed.cProgress': 'Tiến độ',
  'ed.cDue': 'Hạn',
  'ed.noExam': 'Không có bài nào khớp',
  'ed.takeQuiz': 'Làm bài kiểm tra',
  'ed.noWrite': 'Chưa mở ghi ở bản này',
  'ed.addCert': '+ Thêm chứng chỉ',
});
addMessages('en', {
  'ed.learning': 'Learning',
  'ed.dueSoon': 'Mandatory due soon',
  'ed.forSeat': 'Suggested for seat',
  'ed.certsSoon': 'Certificates expiring soon',
  'ed.renewed': 'Renewal form downloaded',
  'ed.renew': 'Download renewal form',
  'ed.allValid': 'All valid',
  'ed.continue': 'Continue',
  'ed.reconnecting': 'Reconnecting…',
  'ed.retry': 'Retry',
  'ed.openLib': 'Open Library',
  'ed.extend': 'Renew',
  'ed.hPerson': 'Person',
  'ed.hCert': 'Certificate',
  'ed.hSource': 'Source',
  'ed.hExpires': 'Expires',
  'ed.hStatus': 'Status',
  'ed.hScan': 'Scan',
  'ed.noCert': 'No matching certificates',
  'ed.lDoc': 'Document',
  'ed.lType': 'Type',
  'ed.lDept': 'Department',
  'ed.lUpdated': 'Updated',
  'ed.quizTitle': 'Quizzes generated by Ask HANA from the SOP in force · approved by the SOP owner',
  'ed.quiz': 'Quiz ⓘ',
  'ed.noDoc': 'No matching documents',
  'ed.cCourse': 'Course',
  'ed.cContent': 'Content',
  'ed.cProgress': 'Progress',
  'ed.cDue': 'Due',
  'ed.noExam': 'No matching exams',
  'ed.takeQuiz': 'Take quiz',
  'ed.noWrite': 'Writing is not enabled in this version',
  'ed.addCert': '+ Add certificate',
});
